// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locaPackCard {
  padding: 0.75rem;
  border-bottom: 1px solid #dadce0;
  padding: 1.5rem 0;
  width: 100%;
  cursor: pointer; }
  .locaPackCard__title {
    font-size: 1.8rem;
    color: #202124;
    line-height: 2rem;
    margin-bottom: 1rem;
    cursor: pointer;
    margin-bottom: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 30rem;
    overflow: hidden; }
    .locaPackCard__title:hover {
      text-decoration: underline; }
  .locaPackCard .guaranteedTag {
    display: flex;
    align-items: center; }
    .locaPackCard .guaranteedTag svg {
      width: 1.2rem; }
    .locaPackCard .guaranteedTag .googleGuaranteedText {
      font-size: 1.2rem;
      text-transform: uppercase; }
  .locaPackCard .detailContainer {
    display: flex;
    align-items: center;
    justify-content: space-between; }
    .locaPackCard .detailContainer .wrapper {
      display: flex;
      gap: 1rem; }
      .locaPackCard .detailContainer .wrapper .userImage {
        width: 6.5rem;
        height: 6.5rem;
        border-radius: 1rem; }
      .locaPackCard .detailContainer .wrapper .placeImage {
        height: 11.4rem;
        width: 11.4rem;
        object-fit: cover;
        border-radius: 1rem; }
    .locaPackCard .detailContainer .detail {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      color: #4d5156;
      font-size: 1.4rem;
      padding-top: 0.5rem; }
      .locaPackCard .detailContainer .detail .innerDetails {
        display: flex;
        flex-direction: column;
        gap: 0.7rem;
        color: #70757a;
        font-size: 1.4rem;
        padding-top: 0.4rem;
        cursor: pointer; }
      .locaPackCard .detailContainer .detail .reviewText {
        display: flex;
        align-items: center;
        gap: 1rem; }
        .locaPackCard .detailContainer .detail .reviewText img {
          width: 1.6rem;
          height: 1.6rem; }
      .locaPackCard .detailContainer .detail .experience {
        display: flex;
        align-items: center;
        width: 100%; }
        .locaPackCard .detailContainer .detail .experience .businessAge {
          min-width: -moz-fit-content;
          min-width: fit-content; }
        .locaPackCard .detailContainer .detail .experience .address {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden; }
      .locaPackCard .detailContainer .detail .adCardDetail_rating {
        display: flex;
        align-items: center;
        height: 1rem;
        gap: 0.5rem; }
        .locaPackCard .detailContainer .detail .adCardDetail_rating .starImages {
          display: flex; }
          .locaPackCard .detailContainer .detail .adCardDetail_rating .starImages .stars {
            width: 1.5rem; }
            .locaPackCard .detailContainer .detail .adCardDetail_rating .starImages .stars img {
              width: 100%; }
        .locaPackCard .detailContainer .detail .adCardDetail_rating__rate {
          color: red; }
      .locaPackCard .detailContainer .detail .callContainer {
        padding-top: 2rem; }
        .locaPackCard .detailContainer .detail .callContainer .phone {
          display: flex;
          align-items: center;
          color: #1a0dab;
          gap: 1rem;
          align-items: center; }
      .locaPackCard .detailContainer .detail .messageContainer {
        padding-top: 2rem; }
        .locaPackCard .detailContainer .detail .messageContainer .message {
          display: flex;
          align-items: center;
          color: #1a0dab;
          gap: 1rem;
          align-items: center; }
      .locaPackCard .detailContainer .detail .message {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        cursor: pointer; }
        .locaPackCard .detailContainer .detail .message svg {
          background-color: transparent;
          border: 1px solid #dadce0;
          border-radius: 50%;
          padding: 1.2rem;
          color: #1a73e8;
          text-align: center; }
        .locaPackCard .detailContainer .detail .message span {
          color: #1a73e8;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 2rem; }
  .locaPackCard .adLinks {
    display: flex;
    align-items: center;
    gap: 2rem; }
    .locaPackCard .adLinks .direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;
      align-items: center;
      cursor: pointer; }
      .locaPackCard .adLinks .direction i {
        background-color: transparent;
        border: 1px solid #dadce0;
        border-radius: 50%;
        padding: 1.4rem;
        font-size: 1.8rem;
        color: #1a73e8; }
      .locaPackCard .adLinks .direction span {
        color: #1a73e8;
        font-size: 1.4rem;
        font-weight: 400;
        line-height: 2rem; }
    .locaPackCard .adLinks .website {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;
      cursor: pointer; }
      .locaPackCard .adLinks .website i {
        background-color: transparent;
        border: 1px solid #dadce0;
        border-radius: 50%;
        padding: 1.4rem;
        font-size: 1.6rem;
        color: #1a73e8;
        text-align: center; }
      .locaPackCard .adLinks .website span {
        color: #1a73e8;
        font-size: 1.4rem;
        font-weight: 400;
        line-height: 2rem; }
  .locaPackCard .message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    cursor: pointer; }
    .locaPackCard .message svg {
      background-color: transparent;
      border: 1px solid #dadce0;
      border-radius: 50%;
      padding: 1.4rem;
      font-size: 1.8rem;
      color: #1a73e8;
      text-align: center; }
    .locaPackCard .message span {
      color: #1a73e8;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 2rem; }
  .locaPackCard .phone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    cursor: pointer; }
    .locaPackCard .phone i {
      background-color: transparent;
      border: 1px solid #dadce0;
      border-radius: 50%;
      padding: 1.4rem;
      font-size: 1.4rem;
      color: #1a73e8;
      text-align: center; }
    .locaPackCard .phone span {
      color: #1a73e8;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 2rem; }
`, "",{"version":3,"sources":["webpack://./src/components/LocalPackCard/LocalPackCard.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,eAAe,EAAA;EACf;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB,EAAA;IAVjB;MAYG,0BAA0B,EAAA;EAlBhC;IAsBI,aAAa;IACb,mBAAmB,EAAA;IAvBvB;MA0BM,aAAa,EAAA;IA1BnB;MA6BM,iBAAiB;MACjB,yBAAyB,EAAA;EA9B/B;IAkCI,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IApClC;MAsCM,aAAa;MACb,SAAS,EAAA;MAvCf;QAyCQ,aAAa;QACb,cAAc;QACd,mBAAmB,EAAA;MA3C3B;QA8CQ,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,mBAAmB,EAAA;IAjD3B;MAqDM,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,cAAc;MACd,iBAAiB;MACjB,mBAAmB,EAAA;MA1DzB;QA4DQ,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,eAAe,EAAA;MAlEvB;QAqEQ,aAAa;QACb,mBAAmB;QACnB,SAAS,EAAA;QAvEjB;UAyEU,aAAa;UACb,cAAc,EAAA;MA1ExB;QA8EQ,aAAa;QACb,mBAAmB;QACnB,WAAW,EAAA;QAhFnB;UAmFU,2BAAsB;UAAtB,sBAAsB,EAAA;QAnFhC;UAsFU,mBAAmB;UACnB,uBAAuB;UACvB,gBAAgB,EAAA;MAxF1B;QA4FQ,aAAa;QACb,mBAAmB;QACnB,YAAY;QACZ,WAAW,EAAA;QA/FnB;UAiGU,aAAa,EAAA;UAjGvB;YAmGY,aAAa,EAAA;YAnGzB;cAqGc,WAAW,EAAA;QArGzB;UA2GU,UAAU,EAAA;MA3GpB;QA+GQ,iBAAiB,EAAA;QA/GzB;UAiHU,aAAa;UACb,mBAAmB;UACnB,cAAc;UACd,SAAS;UACT,mBAAmB,EAAA;MArH7B;QAyHQ,iBAAiB,EAAA;QAzHzB;UA2HU,aAAa;UACb,mBAAmB;UACnB,cAAc;UACd,SAAS;UACT,mBAAmB,EAAA;MA/H7B;QAmIQ,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,eAAe,EAAA;QAxIvB;UA0IU,6BAA6B;UAC7B,yBAAyB;UACzB,kBAAkB;UAClB,eAAe;UACf,cAAc;UACd,kBAAkB,EAAA;QA/I5B;UAkJU,cAAc;UACd,iBAAiB;UACjB,gBAAgB;UAChB,iBAAiB,EAAA;EArJ3B;IA2JI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;IA7Jb;MA+JM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;MACT,mBAAmB;MACnB,eAAe,EAAA;MApKrB;QAsKQ,6BAA6B;QAC7B,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,cAAc,EAAA;MA3KtB;QA8KQ,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB,EAAA;IAjLzB;MAqLM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;MACT,eAAe,EAAA;MAzLrB;QA2LQ,6BAA6B;QAC7B,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,kBAAkB,EAAA;MAjM1B;QAoMQ,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB,EAAA;EAvMzB;IA4MI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;IAjNnB;MAmNM,6BAA6B;MAC7B,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;IAzNxB;MA4NM,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB,EAAA;EA/NvB;IAmOI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;IAxOnB;MA0OM,6BAA6B;MAC7B,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;IAhPxB;MAmPM,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB,EAAA","sourcesContent":[".locaPackCard {\n  padding: 0.75rem;\n  border-bottom: 1px solid #dadce0;\n  padding: 1.5rem 0;\n  width: 100%;\n  cursor: pointer;\n  &__title {\n    font-size: 1.8rem;\n    color: #202124;\n    line-height: 2rem;\n    margin-bottom: 1rem;\n    cursor: pointer;\n    margin-bottom: 0;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 30rem;\n    overflow: hidden;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  .guaranteedTag {\n    display: flex;\n    align-items: center;\n\n    svg {\n      width: 1.2rem;\n    }\n    .googleGuaranteedText {\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n  }\n  .detailContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .wrapper {\n      display: flex;\n      gap: 1rem;\n      .userImage {\n        width: 6.5rem;\n        height: 6.5rem;\n        border-radius: 1rem;\n      }\n      .placeImage {\n        height: 11.4rem;\n        width: 11.4rem;\n        object-fit: cover;\n        border-radius: 1rem;\n      }\n    }\n    .detail {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      color: #4d5156;\n      font-size: 1.4rem;\n      padding-top: 0.5rem;\n      .innerDetails {\n        display: flex;\n        flex-direction: column;\n        gap: 0.7rem;\n        color: #70757a;\n        font-size: 1.4rem;\n        padding-top: 0.4rem;\n        cursor: pointer;\n      }\n      .reviewText {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        img {\n          width: 1.6rem;\n          height: 1.6rem;\n        }\n      }\n      .experience {\n        display: flex;\n        align-items: center;\n        width: 100%;\n\n        .businessAge {\n          min-width: fit-content;\n        }\n        .address {\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n      }\n      .adCardDetail_rating {\n        display: flex;\n        align-items: center;\n        height: 1rem;\n        gap: 0.5rem;\n        .starImages {\n          display: flex;\n          .stars {\n            width: 1.5rem;\n            img {\n              width: 100%;\n            }\n          }\n        }\n\n        &__rate {\n          color: red;\n        }\n      }\n      .callContainer {\n        padding-top: 2rem;\n        .phone {\n          display: flex;\n          align-items: center;\n          color: #1a0dab;\n          gap: 1rem;\n          align-items: center;\n        }\n      }\n      .messageContainer {\n        padding-top: 2rem;\n        .message {\n          display: flex;\n          align-items: center;\n          color: #1a0dab;\n          gap: 1rem;\n          align-items: center;\n        }\n      }\n      .message {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 1rem;\n        cursor: pointer;\n        svg {\n          background-color: transparent;\n          border: 1px solid #dadce0;\n          border-radius: 50%;\n          padding: 1.2rem;\n          color: #1a73e8;\n          text-align: center;\n        }\n        span {\n          color: #1a73e8;\n          font-size: 1.4rem;\n          font-weight: 400;\n          line-height: 2rem;\n        }\n      }\n    }\n  }\n  .adLinks {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    .direction {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      gap: 1rem;\n      align-items: center;\n      cursor: pointer;\n      i {\n        background-color: transparent;\n        border: 1px solid #dadce0;\n        border-radius: 50%;\n        padding: 1.4rem;\n        font-size: 1.8rem;\n        color: #1a73e8;\n      }\n      span {\n        color: #1a73e8;\n        font-size: 1.4rem;\n        font-weight: 400;\n        line-height: 2rem;\n      }\n    }\n    .website {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      gap: 1rem;\n      cursor: pointer;\n      i {\n        background-color: transparent;\n        border: 1px solid #dadce0;\n        border-radius: 50%;\n        padding: 1.4rem;\n        font-size: 1.6rem;\n        color: #1a73e8;\n        text-align: center;\n      }\n      span {\n        color: #1a73e8;\n        font-size: 1.4rem;\n        font-weight: 400;\n        line-height: 2rem;\n      }\n    }\n  }\n  .message {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    svg {\n      background-color: transparent;\n      border: 1px solid #dadce0;\n      border-radius: 50%;\n      padding: 1.4rem;\n      font-size: 1.8rem;\n      color: #1a73e8;\n      text-align: center;\n    }\n    span {\n      color: #1a73e8;\n      font-size: 1.4rem;\n      font-weight: 400;\n      line-height: 2rem;\n    }\n  }\n  .phone {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    i {\n      background-color: transparent;\n      border: 1px solid #dadce0;\n      border-radius: 50%;\n      padding: 1.4rem;\n      font-size: 1.4rem;\n      color: #1a73e8;\n      text-align: center;\n    }\n    span {\n      color: #1a73e8;\n      font-size: 1.4rem;\n      font-weight: 400;\n      line-height: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
